<template>
  <el-dialog title="不予受理" :visible.sync="showDialog" append-to-body width="50%">
    <el-form :model="ruleForm" size="small" :rules="rules" ref="ruleForm" label-width="110px">
      <el-form-item label="不予受理原因" prop="remark">
        <el-input type="textarea" v-model="ruleForm.remark"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">提交</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
// 状态映射到对应的API方法
const STATUS_API_MAP = {
  1: 'chuhe',   // 初核
  2: 'shouli',  // 受理
  3: 'shencha'  // 审查
}

export default {
  data() {
    return {
      showDialog: false,
      ruleForm: { remark: '' },
      rules: {
        remark: [{ required: true, message: '请填写不予受理原因', trigger: 'blur' }]
      },
      id: null,
      status: null
    }
  },
  methods: {
    async submitForm() {
      try {
        // 验证表单
        const valid = await this.$refs.ruleForm.validate()
        if (!valid) return

        // 检查是否支持的状态
        if (!STATUS_API_MAP[this.status]) {
          this.$message.error('当前状态不支持不予受理操作')
          return
        }

        // 获取API方法
        const apiMethod = this.$api[STATUS_API_MAP[this.status]]

        // 调用API
        const res = await apiMethod({
          approverStatus: 1, // 1表示驳回
          remark: this.ruleForm.remark,
          contractId: this.id,
          currentStatus: this.status // 传递当前状态
        })

        // 处理响应
        if (res.data.code === '200') {
          this.$message.success('操作成功')
          this.close()
          this.$emit('success', {
            id: this.id,
            status: this.status
          })
        } else {
          this.$message.error(res.data.message || '操作失败')
        }
      } catch (error) {
        console.error('操作失败:', error)
        this.$message.error('请求失败，请稍后重试')
      }
    },
    open(id, status) {
      // 只允许在初核、受理、审查状态下操作
      if ([1, 2, 3].includes(status)) {
        this.id = id
        this.status = status
        this.ruleForm.remark = '' // 重置表单
        this.showDialog = true
      } else {
        this.$message.warning('当前状态不能进行不予受理操作')
      }
    },
    close() {
      this.showDialog = false
    }
  }
}
</script>